var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    viewBox: "0 0 44 38.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2599",
    "data-name": "Groupe 2599",
    transform: "translate(-1388.154 -237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_330",
    "data-name": "Ellipse 330",
    transform: "translate(1391 237)",
    fill: "none",
    stroke: "#313d57",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 17.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2560",
    "data-name": "Groupe 2560",
    transform: "translate(-249 -295)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "T",
    transform: "translate(1637.154 537.838)",
    fill: "#313d57",
    fontSize: 20,
    fontFamily: "Hind-Bold, Hind",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16.322,
    y: 21
  }, "T"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIcon);
export default __webpack_public_path__ + "static/media/template-icon.5c82b554d803930f2cf42f53b660b8d1.svg";
export { ForwardRef as ReactComponent };